import React from "react";
import { ClipboardList, CalendarClock, ScanSearch, Camera, Timer, ShieldCheck } from "lucide-react";
import { MEMBERSHIP_INCLUDES } from "@/data/maintenancePlans";

const ICONS = {
  ClipboardList,
  CalendarClock,
  ScanSearch,
  Camera,
  Timer,
  ShieldCheck,
};

export default function MembershipIncludesCards() {
  return (
    <section className="section-pad bg-white" id="what-included" data-testid="membership-includes">
      <div className="container-br">
        <div className="max-w-3xl mb-8">
          <div className="br-eyebrow">What You Are Actually Paying For</div>
          <h2 className="br-headline text-3xl sm:text-4xl mt-3">What Your Membership Actually Includes</h2>
          <p className="mt-3 text-gray-700 leading-relaxed">
            A Black Ridge maintenance membership is not just a monthly charge. It is a recurring property-care system designed to document your home, keep routine maintenance on schedule, and give you a reliable contractor relationship when issues come up.
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {MEMBERSHIP_INCLUDES.map((c) => {
            const Icon = ICONS[c.icon] || ClipboardList;
            return (
              <div key={c.title} className="bg-br-paper border border-gray-200 rounded p-5 hover:border-br-bronze transition" data-testid={`includes-card-${c.title.toLowerCase().replace(/[^a-z0-9]+/g,"-")}`}>
                <div className="w-10 h-10 rounded-full bg-br-bronze/10 flex items-center justify-center text-br-bronze mb-3">
                  <Icon size={18} />
                </div>
                <div className="font-display text-base tracking-widest uppercase mb-2">{c.title}</div>
                <p className="text-sm text-gray-700 leading-relaxed">{c.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
